import api from './api';

export const getRiepilogo = async (cantiereId) => {
  const res = await api.get(`/budget/riepilogo/${cantiereId}`, { withCredentials: true });
  const payload = res?.data?.data ?? res?.data ?? {};
  return { data: payload };
};

export const saveRiepilogo = async (cantiereId, dati) => {
  const res = await api.post(`/budget/riepilogo/${cantiereId}`, dati, { withCredentials: true });
  // In molti casi il backend ritorna { success, salvati }, ma qui restituiamo i dati normalizzati per coerenza
  const payload = res?.data?.data ?? res?.data ?? {};
  return { data: payload };
};

export const deleteRigaRiepilogo = async (id) => {
  const res = await api.delete(`/budget/riepilogo/${id}`, { withCredentials: true });
  return res.data;
};